import React from 'react';
import { useEffect, useState, useMemo, useContext } from 'react'
import { Dropdown, Tooltip, Spin, Typography, Image } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next"
import i18n from "../i18n"
import config from '../botconfig'
import IconRu from '../svg/ruFlag'
import IconGb from '../svg/enFlag'
import botconfig from '../botconfig';
import { ThemeSwitcher } from './ThemeSwitcher'
import { LanguageContext } from '../contexts/language'
const { Text } = Typography;
export function AppHeader() {
    const [ language, toggleLanguage ] = useContext(LanguageContext)
    const { t } = useTranslation()
    const [isLogged, setIsLogged] = useState(false)
    const [loading, setLoading] = useState(true)
    const [user, setUser] = useState()
    const handleClick = () => {
        window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
    }
    const openMenu = () => {
        const element = document.getElementById("menu")
        element.classList.toggle("hide")
        element.classList.toggle("show")
    }
    
    const handleLanguageChange = (e) => {
        i18n.changeLanguage(e.key)
        toggleLanguage(e.key)
    }
    const handleMenuClick = (e) => {
        switch (e.key) {
            case "servers": {
                window.location.replace(`${botconfig.root_path}${botconfig.website_port}/servers`)
                break
            }
            case "logout": {
                localStorage.removeItem("wetbot")
                window.location.replace(botconfig.root_path+botconfig.website_port)
                break
            }
        }
    };
    useEffect(() => {
        async function preload() {
            let localItem = JSON.parse(localStorage.getItem("wetbot"))
            if (localItem && localItem.token) {
                setUser(localItem.user)
                setIsLogged(true)
            }    
        }
        preload()
        window.addEventListener("scroll", (e) => {
            const element = document.getElementById("header_container")
            if (e.currentTarget.scrollY > 0 && ![...element.classList].includes("is_scrolled")) {
                element.classList.toggle("is_scrolled")
            } else if (e.currentTarget.scrollY === 0 && [...element.classList].includes("is_scrolled")) {
                element.classList.remove("is_scrolled")
            }
        });
        setLoading(false)
    }, [])
    const [arrow, setArrow] = useState('Show');
    const mergedArrow = useMemo(() => {
        if (arrow === 'Hide') {
            return false;
        }
        if (arrow === 'Show') {
            return true;
        }
        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const items = [
        {
            label: <div style={{ display: "flex", width: 200, alignItems: "center", gap: 10 }}><svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M2 4C2 2.34315 3.34315 1 5 1H19C20.6569 1 22 2.34315 22 4V6C22 7.04349 21.4672 7.96254 20.6589 8.5C21.4672 9.03746 22 9.95651 22 11V13C22 14.0435 21.4672 14.9625 20.6589 15.5C21.4672 16.0375 22 16.9565 22 18V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V18C2 16.9565 2.53276 16.0375 3.34111 15.5C2.53276 14.9625 2 14.0435 2 13V11C2 9.95651 2.53275 9.03746 3.3411 8.5C2.53275 7.96254 2 7.04349 2 6V4ZM5 3C4.44772 3 4 3.44772 4 4V6C4 6.55228 4.44772 7 5 7H19C19.5523 7 20 6.55228 20 6V4C20 3.44772 19.5523 3 19 3H5ZM5 10C4.44772 10 4 10.4477 4 11V13C4 13.5523 4.44772 14 5 14H19C19.5523 14 20 13.5523 20 13V11C20 10.4477 19.5523 10 19 10H5ZM4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V18ZM16.5 20.25C17.1904 20.25 17.75 19.6904 17.75 19C17.75 18.3096 17.1904 17.75 16.5 17.75C15.8096 17.75 15.25 18.3096 15.25 19C15.25 19.6904 15.8096 20.25 16.5 20.25ZM16.5 13.25C17.1904 13.25 17.75 12.6904 17.75 12C17.75 11.3096 17.1904 10.75 16.5 10.75C15.8096 10.75 15.25 11.3096 15.25 12C15.25 12.6904 15.8096 13.25 16.5 13.25ZM16.5 6.25C17.1904 6.25 17.75 5.69036 17.75 5C17.75 4.30964 17.1904 3.75 16.5 3.75C15.8096 3.75 15.25 4.30964 15.25 5C15.25 5.69036 15.8096 6.25 16.5 6.25Z" fill="var(--cookie-color)"></path> </g></svg><Text style={{ textAlign: "center" }}>{t('Мои серверы')}</Text></div>,
            key: 'servers',
        },
        {
            label: <div style={{ display: "flex", width: 200, alignItems: "center", gap: 10 }}><svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21 12L13 12" stroke="var(--cookie-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9" stroke="var(--cookie-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19" stroke="var(--cookie-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg><Text style={{ textAlign: "center" }}>{t('Выйти')}</Text></div>,
            key: 'logout',
        }
    ];
    const languages = [
        {
            label: <div style={{ display: "flex" }}><IconRu/><Text style={{ paddingLeft: 3, textAlign: "center" }}>Русский</Text></div>,
            key: 'ru',
        },
        {
            label: <div style={{ display: "flex" }}><IconGb/><Text style={{ paddingLeft: 3, textAlign: "center" }}>English</Text></div>,
            key: 'en-GB',
        }
    ];
    const contentStyle = {
        zIndex: 2000,
    };
    const menuStyle = {
        zIndex: 2000,
        boxShadow: 'none',
        borderRadius: "0px 0px 8px 8px"
    };
    return (
        <>
            <div className="header_root">
                <div className='header__menu hide' id="menu">
                    <div className='header__menu__container'>
                        { !isLogged ? <div className='header__menu__container__item' onClick={handleClick}>{t('Войти')}</div> : undefined }
                        <a target="_blank" rel="noopener noreferrer" href={language === "ru" ? 'https://docs.wetbot.space' : 'https://docs.wetbot.space/v/eng'} className='header__menu__container__item'>{t('Документация')}</a>
                        <a target="_blank" rel="noopener noreferrer" href={config.supportServerInvite} className='header__menu__container__item'>{t('Сервер поддержки')}</a>
                        {/* <a href="" className='header__menu__container__item'><span className='gradient_premium'>{t('Премиум')}</span></a>  */}
                    </div>
                    <div className='header__menu__overlay' onClick={() => {
                        const element = document.getElementById("menu")
                        element.classList.toggle("hide")
                        element.classList.toggle("show")
                    }}/>
                </div>
                <div className="header_container" id="header_container">
                    <div className='header_content'>
                        <div className="header__inner__left">
                            <a href={`${botconfig.root_path}${botconfig.website_port}`} style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                                <img src="https://i.postimg.cc/dtxmzF7K/wetbot-new2234-1.png" alt="" className="header__inner__left__logo"/>
                                <span className="wetbot_span font-800">WETBOT</span>
                            </a>
                            <button className='button header_button' onClick={() => window.open(language === "ru" ? 'https://docs.wetbot.space' : 'https://docs.wetbot.space/v/eng')}>{t('Документация')}</button>
                            <button className='button header_button' onClick={() => window.open(config.supportServerInvite, undefined, "popup=yes")}>{t('Сервер поддержки')}</button>
                            {/* <button className='button header_button_premium' onClick={handleClick}>{t('Премиум')}</button> */}
                        </div>
                        <div className="header__inner__right">
                            { loading ?
                                <Spin indicator={<LoadingOutlined style={{ fontSize: 50, color: "var(--cookie-color)" }} spin />} /> : 
                                isLogged ?
                                    <>  <ThemeSwitcher></ThemeSwitcher>
                                        <Dropdown
                                            menu={{ items: languages, onClick: handleLanguageChange }}
                                            trigger={['click']}
                                            placement="bottomRight"
                                        >
                                            <button className='button language_button'>{ language === "ru" ? <IconRu/> : language === "en-GB" ? <IconGb/> : "Язык" }</button>
                                        </Dropdown>
                                        <Dropdown
                                            menu={{ items, onClick: handleMenuClick }}
                                            trigger={['click']}
                                            arrow={mergedArrow}
                                            dropdownRender={(menu) => (
                                                <div style={contentStyle}>
                                                    <div style={{ display: "flex", alignItems: "center", width: 300, height: 105, backgroundColor: user?.banner_color || "hsl(228 6.7% 14.7%)", borderTopLeftRadius: 7, borderTopRightRadius: 7 }}>
                                                        {user?.banner ? <Image style={{ zIndex: 0, width: "100%", height: "100%", borderTopLeftRadius: 6, borderTopRightRadius: 6, filter: "brightness(50%)", objectFit: "cover" }} src={`https://cdn.discordapp.com/banners/${user?.id}/${user?.banner}.png?size=300`} alt="Banner" preview={false}/> : undefined}
                                                        <div style={{ position: "absolute", display: 'flex', alignItems: "center" }}>
                                                            <Image style={{ marginLeft: 20, borderRadius: "50%", width: 50 }} src={`https://cdn.discordapp.com/avatars/${user?.id}/${user?.avatar}.png`} alt="https://freelogopng.com/images/all_img/1691730813discord-icon-png.png" preview={false}/>
                                                            <span style={{ paddingLeft: 20, color: "#FFFFFF" }}>{user?.global_name || user?.username}</span>
                                                        </div>
                                                    </div>
                                                    {React.cloneElement(menu, { style: menuStyle })}
                                                </div>
                                            )}>
                                            <Image className="avatar" width='50px' src={`https://cdn.discordapp.com/avatars/${user?.id}/${user?.avatar}.png`} fallback="https://freelogopng.com/images/all_img/1691730813discord-icon-png.png" preview={false}/>
                                        </Dropdown>
                                        <button className="menu_button" onClick={openMenu}>
                                            <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20M4 12H20M4 18H20" stroke="var(--cookie-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                                        </button>
                                    </> : 
                                    <>
                                        <ThemeSwitcher></ThemeSwitcher>
                                        <Dropdown
                                            menu={{ items: languages, onClick: handleLanguageChange }}
                                            trigger={['click']}
                                            placement="bottomRight"
                                        >
                                            <button className='button language_button'>{ language === "ru" ? <IconRu/> : language === "en-GB" ? <IconGb/> : "Язык" }</button>
                                        </Dropdown>
                                        <button className='button header_button' onClick={handleClick}>{t('Войти')}</button>
                                        <button className="menu_button" onClick={openMenu}>
                                            <svg width="54px" height="54px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20M4 12H20M4 18H20" stroke="var(--cookie-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                                        </button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}